import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Returns whether the control has a duplicate in the list of items.
 * Returns error of form { duplicate: true }.
 *
 * @param items List of string items.
 * @returns ValidatorFn
 */
export function DsLibDuplicateValidator(items: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const lowerCaseItems = items.map((item) => item.toLowerCase());
    if (lowerCaseItems.includes(control.value.toLowerCase())) {
      return { duplicate: true };
    }
    return null;
  };
}
